const OUTBOUND_HOSTS = new Set(['algoretico.it', 'www.algoretico.it', 'scriba-ai.dev', 'www.scriba-ai.dev', 'ai-blog.it', 'www.ai-blog.it'])
const BOOK_HOST = 'leggi.michelelaurelli.it'

const hasAnalyticsConsent = () => {
    const entry = document.cookie.split(';').map((cookie) => cookie.trim()).find((cookie) => cookie.startsWith('ml_consent='))
    if (!entry) return false
    try {
        return JSON.parse(decodeURIComponent(entry.slice('ml_consent='.length))).analytics === true
    } catch {
        return false
    }
}

const track = (name, parameters = {}) => {
    if (!hasAnalyticsConsent() || typeof window.gtag !== 'function') return
    window.gtag('event', name, parameters)
}

export default function initAnalytics() {
    if (window.__mlAnalytics || window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/')) return
    window.__mlAnalytics = true

    document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href]')
        if (!link) return

        if (link.hasAttribute('data-pillar-click')) {
            track('pillar_click', { destination: link.href, source_page: window.location.pathname })
            return
        }
        if (link.hasAttribute('data-glossary-to-article')) {
            track('glossary_to_article', { destination: link.href, source_page: window.location.pathname })
            return
        }

        let url
        try { url = new URL(link.href, window.location.href) } catch { return }

        if (url.hostname === BOOK_HOST) {
            track('book_click', { source_page: window.location.pathname, destination: url.href })
            return
        }
        if (OUTBOUND_HOSTS.has(url.hostname)) {
            track('outbound_click', { destination: url.hostname, link_url: url.href, source_page: window.location.pathname })
            return
        }
        if (url.protocol === 'mailto:' || link.hasAttribute('data-contact-click') || /(?:^|\/)(?:contatti|contact)(?:\/|$)/.test(url.pathname) || url.hash === '#contact-section') {
            track('contact_click', { destination: url.protocol === 'mailto:' ? 'email' : url.href, source_page: window.location.pathname })
        }
    })
    window.addEventListener('ml-tool-interaction', (event) => {
        track('tool_interaction', { tool: event.detail.tool, source_page: window.location.pathname })
    })
    window.addEventListener('ml-tool-share', (event) => {
        track('tool_share', { tool: event.detail.tool, source_page: window.location.pathname })
    })
}
